// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"701":"f8eced6b","831":"341dfc32"}[chunkId] + ".chunk.js";
};